var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9852C0 25.0872 0.904015 25.9778 1.95753 25.9778H21.6061V45.9687C21.6061 47.0503 22.481 47.9704 23.5637 47.9704C24.6463 47.9704 25.5414 47.0503 25.5414 45.9687V25.9778H45.1608C46.2233 25.9778 47.1273 25.0872 47.1273 23.9852C47.1273 22.8832 46.2233 21.963 45.1608 21.963H25.5414V1.99256C25.5414 0.920188 24.6463 0 23.5637 0C22.481 0 21.6061 0.920188 21.6061 1.99256V21.963H1.95753C0.904015 21.963 0 22.8832 0 23.9852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cf349ec71bfcef6be57939e4b5873c2b.svg";
export { ForwardRef as ReactComponent };